<template>
<div class="foot-contaienr">
  <!-- <FootOrderInfo style="margin-right: 19px"></FootOrderInfo>
  <FootPieChart style="margin-right: 36px"></FootPieChart> -->
  <TransactionRecord style="margin-right: 19px"
                      name="干线"
                      :price="price[0].aturnover"
                      :listData="list1" :min="3000" :max="20000">
  </TransactionRecord>
  <TransactionRecord style="margin-right: 36px"
                      name="支线"
                      :price="price[1].aturnover"
                      :listData="list2" :min="1000" :max="6000">
  </TransactionRecord>
  <TransactionRecord style="margin-right: 19px"
                     name="配送"
                     :price="price[2].aturnover"
                     :listData="list3" :min="500" :max="3000">
  </TransactionRecord>
  <TransactionRecord name="仓储"
                     :price="price[3].aturnover"
                     :setp="0.5"
                     :listData="list4" :min="4000" :max="30000">
  </TransactionRecord>
</div>
</template>

<script>
import {
  getGX,
  getZX,
  getCP,
  getCC
} from '../../../api/colunm3'
import TransactionRecord from './TransactionRecord.vue'
export default {
  components: {
    TransactionRecord
  },

  props: {
    price: Array
  },

  data () {
    return {
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      timer1: null,
      timer2: null,
      timer3: null,
      timer4: null
    }
  },

  created () {
    this.getGx()
    this.getZX()
    this.getCP()
    this.getCC()
  },

  methods: {
    getGx () {
      getGX().then(res => {
        this.list1 = res
        this.timer && clearInterval(this.timer)
        this.timer = setTimeout(this.getGx, 1000 * 60)
      })
    },

    getZX () {
      getZX().then(res => {
        this.list2 = res
        this.timer && clearInterval(this.timer)
        this.timer = setTimeout(this.getZX, 1000 * 60)
      })
    },

    getCP () {
      getCP().then(res => {
        this.list3 = res
        this.timer3 && clearInterval(this.timer3)
        this.timer3 = setTimeout(this.getCP, 1000 * 60)
      })
    },

    getCC () {
      getCC().then(res => {
        this.list4 = res
        this.timer4 && clearInterval(this.timer4)
        this.timer4 = setTimeout(this.getCC, 1000 * 60)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.foot-contaienr {
  display: flex;
  height: 291px;
  .foot-pie-chart  {
    margin-right: 36px;
  }
}
</style>